import React from 'react';
import SosdbRoleActionForm from '../SosdbRoleActionForm';
import { browserHistory } from 'react-router';
import SosdbRoleAction from '../../model/SosdbRoleAction';
import * as actions from '../../redux/actions';

class SosdbRoleActionEditPage extends React.Component {
  state = {
    statusMessage: '',
  };

  componentWillMount() {
    const { dispatch, roleActionList } = this.props;
    // to handle browser page refresh on this page
    if (roleActionList.length == 0) {
      dispatch(actions.getSosdbRoleActionList());
    }
  }

  handleSubmit(values) {
    //console.log('roleAction update', values);
    const { dispatch } = this.props;
    return dispatch(actions.updateSosdbRoleAction(new SosdbRoleAction(values)))
      .then((roleAction) => {
        //console.log('updated roleAction', roleAction);
        browserHistory.goBack();
      })
      .catch((e) => {
        this.setState({ statusMessage: e.message }, () => {
          let $statusMessage = $(this.refs.statusMessage);
          $statusMessage.removeClass('animated fadeIn');
          setTimeout(() => $statusMessage.addClass('animated fadeIn'), 200);
        });
      });
  }

  goBack() {
    browserHistory.goBack();
  }

  render() {
    let { statusMessage } = this.state;
    let { roleActionList, params, auth } = this.props;
    let filteredList = roleActionList.filter((roleAction) => {
      return roleAction.id === params.id;
    });
    let roleAction = filteredList[0] || {};

    let loggedInUser = auth.user;
    let initialValues = roleAction;
    initialValues.isCreate = false;

    return (
      <div className='user-page'>
        <div className='title-row user-title'>
          <div className='title-back cursor-pointer' onClick={this.goBack.bind(this)}>
            <i className='fa fa-chevron-left' />
          </div>
          <div className='title' style={{ paddingLeft: '10px' }}>
            Update Role Action
          </div>
        </div>

        {statusMessage && (
          <div className='error-message-bar' ref='statusMessage'>
            <i className='fa fa-warning' /> {statusMessage}
          </div>
        )}
        <SosdbRoleActionForm
          initialValues={initialValues}
          onSubmit={this.handleSubmit.bind(this)}
        />
      </div>
    );
  }
}

export default SosdbRoleActionEditPage;



// WEBPACK FOOTER //
// ./src/components/pages/SosdbRoleActionEditPage.js